module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), (_vm.currentSystem.return_cmpn !== null) ? _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectEvent') ? _c('EventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "device": _vm.currentSystem.return_cmpn
    }
  }) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1) : _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [_vm._m(0)])], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage === 'selectEvent') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始回收",
      "clickable": _vm.$store.state.event.selectedEventId.length !== 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('h3', [_vm._v("請先至首頁設定退藥盒")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3766bf45","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecycleDrug.vue
// module id = 1429
// module chunks = 1